
import { SWRConfiguration, SWRResponse } from "swr";

import { IReturn, QueryParticipants, QueryParticipantsResponse, Participant } from "@/api/dtos";
import { useMemo } from "react";
import useCachedDataQuery from '@/hooks/api/useCachedDataQuery';
import { AppSettings } from "@/AppSettings";

const getAdditionalState = (response?: SWRResponse<QueryParticipantsResponse, QueryParticipantsResponse>) => ({
    idMap: !!response?.data?.data?.length ? response?.data?.data?.reduce<Record<number, Participant>>((a, b) => {
        if (!b?.id) {
            return a;
        }
        
        a[b.id] = b;

        return a;
    },{}) : undefined
});

const sortData = (a: Participant, b: Participant) => a.studyNumber! > b.studyNumber! ? 1 : -1;

export const useParticipants = (query?: Partial<Participant>, configuration?: SWRConfiguration | undefined) => {
    return useCachedDataQuery(QueryParticipants, { sortData, getAdditionalState, channel: AppSettings.channels.participant }, query, configuration);
}

export default useParticipants;